import { graphql } from 'relay-runtime';

export const resetDiagnosticMutation = graphql`
  mutation StudentsResetDiagnosticMutation($studentId: ID!, $diagnosticId: ID!) {
    resetStudentDiagnosticAssessment(input: { studentId: $studentId, studentSkillDiagnosticId: $diagnosticId }) {
      studentSkillDiagnosticNode {
        id
        isInferred
        retakeAssigned
        publicUserId
        user {
          id
          publicUserId
        }
      }
    }
  }
`;

export const studentSkillProgressReportQuery = graphql`
  query StudentsSkillProgressReportQuery($filter: StudentSkillProgressReportFilterInput!, $skip: Boolean = false) {
    studentSkillProgressReport(filter: $filter) @skip(if: $skip) {
      student {
        id
        firstName
        lastName
        publicUserId
      }
      skillIdsBySkillResults {
        key
        value
      }
      roadmapPercentage
      lastLogin
      currentRoadmapId
      currentRoadmapName
    }
  }
`;

export const studentSkillProgressDetailQuery = graphql`
  query StudentsSkillProgressDetailQuery(
    $filter: StudentSkillProgressDetailFilterInput!
    $skip: Boolean = false
    $first: Int
    $after: String
    $last: Int
    $before: String
  ) {
    studentSkillProgressDetail(filter: $filter, first: $first, after: $after, last: $last, before: $before)
      @skip(if: $skip) {
      nodes {
        id
        name
        code
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
      }
    }
  }
`;

export const allStudents = graphql`
  query StudentsAllStudentsQuery(
    $filter: AllStudentsFilterInput!
    $first: Int
    $after: String
    $last: Int
    $skip: Boolean = false
    $before: String
    $order: [UserSortInput!]
  ) {
    allStudents(filter: $filter, first: $first, after: $after, last: $last, before: $before, order: $order)
      @skip(if: $skip) {
      totalCount
      nodes {
        diagnostics {
          id
          isInferred
          retakeAssigned
          sessionCompletedOn
          sessionStartedOn
        }
        id
        firstName
        lastName
        publicUserId
        gradeLevels {
          id
          name
        }
        sites {
          id
          name
        }
        roles {
          id
          name
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;
export const allStudentsWithoutTotal = graphql`
  query StudentsAllStudentsWithoutTotalQuery(
    $filter: AllStudentsFilterInput!
    $first: Int
    $after: String
    $last: Int
    $skip: Boolean = false
    $before: String
    $order: [UserSortInput!]
  ) {
    allStudents(filter: $filter, first: $first, after: $after, last: $last, before: $before, order: $order)
      @skip(if: $skip) {
      nodes {
        diagnostics {
          id
          isInferred
          retakeAssigned
          sessionCompletedOn
          sessionStartedOn
        }
        id
        firstName
        lastName
        classes {
          id
          name
        }
        gradeLevels {
          id
          name
        }
        sites {
          id
          name
        }
        roles {
          id
          name
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const allStudentsCount = graphql`
  query StudentsCountQuery($filter: AllStudentsFilterInput!) {
    allStudents(filter: $filter, first: 1) {
      totalCount
    }
  }
`;
